<template>
  <div class="backimg">
    <img class="nodata-img" src="../../assets/image/nodata.png" alt="" />
    <p>暂无数据</p>
  </div>
</template>

<script>
export default {
  name: "NoData"
};
</script>

<style lang="less" scoped>
.backimg {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 0;
  img{
    max-width: 100%;
    max-height: 100%;
    width: 15.5rem;
    height: auto;
    object-fit: cover;
  }
  p {
    margin-top: 1.5rem;
    font-size: 14px;
    font-weight: normal;
    color: #909399;
  }
}
</style>
